/**
 * 是否私有化部署
 * 私有化部署：true 不需要登录即可访问系统
 * 非私有化部署：false 需要登录访问系统
 */
export let isPrivate = false; // true: 私有化部署 false: 非私有化部署